import {
  Button,
  Cascader,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Pagination,
  Radio,
  Row,
  Select,
  Switch,
  TreeSelect,
} from 'antd'
import { useForm } from 'antd/es/form/Form'
import moment from 'moment'
import React, { useState, useRef, useEffect } from 'react'
import { getPostList } from '../../api/api'
import PostTable from './components/postTable/postTable'
import './index.css'

const { RangePicker } = DatePicker
const PostSelectors = () => {
  const [componentSize, setComponentSize] = useState('default')
  const [postList, setPostList] = useState([])
  const [payload, setPayload] = useState({ page: '1', pagesize: '10' })
  const [total, setTotal] = useState(0)
  const [form] = useForm()
  const postRef = useRef()
  const [isFresh, setIsFresh] = useState(false)

  useEffect(() => {
    // console.log(payload);
    // console.log('fresh',isFresh);
    getPostList({ params: payload }).then((res) => {
      const info = res.data.data
      if (info.total === 0) {
        message.error('未能找到指定条件内容！')
      }
      postRef.current.changeTable(info.rows)
      setTotal(info.total)
    })
  }, [payload, isFresh])

  const pageChange = (e) => {
    //分页改变时的回调函数
    setPayload({
      ...payload,
      page: e,
    })
  }

  const onFormLayoutChange = ({ size }) => {
    setComponentSize(size)
  }

  const handleSubmit = (values) => {
    let payload = {
      page: '1',
      pagesize: '10',
      audit_status: values.audit_status,
      type: values.type,
      is_stiky: values.is_stiky,
    }
    let start = values?.date[0]
    let end = values?.date[1]

    if (start !== '') {
      payload['period_start'] = moment(start).format('YYYY-MM-DD')
    }
    if (end !== '') {
      payload['period_end'] = moment(end).format('YYYY-MM-DD')
    }

    const regPos = /^[0-9]+.?[0-9]*/ //判断是否是数字。
    if (regPos.test(values.title)) {
      payload.id = values.title
      // console.log(payload,"number");
    }else{
      payload.title = values.title
    }

    // console.log(payload)
    setPayload(payload)
  }

  const resetSelectors = () => {
    form.resetFields()
  }
  return (
    <div className="postManage">
      <div className="postSelector">
        <Form
          initialValues={{
            size: componentSize,
            date: ['', ''],
          }}
          onValuesChange={onFormLayoutChange}
          onFinish={handleSubmit}
          size={componentSize}
          form={form}
        >
          <Row>
            <Col span={7}>
              <Form.Item
                label="帖子信息"
                name="title"
                className="postContent"
                labelCol={{ span: 6}}
              >
                <Input placeholder="请输入帖子编号或帖子标题" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="状态"
                name="audit_status"
                className="status"
                labelCol={{ span: 5 }}
              >
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  style={{ textAlign: 'left' }}
                >
                  <Select.Option value="1">待审核</Select.Option>
                  <Select.Option value="2">审核通过</Select.Option>
                  <Select.Option value="3">审核未通过</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="发布时间" name="date" className="postTime">
                <RangePicker />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={7}>
              <Form.Item
                label="类型"
                name="type"
                className="postType"
                labelCol={{ span: 6 }}
              >
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  style={{ textAlign: 'left' }}
                >
                  <Select.Option value="1">合租</Select.Option>
                  <Select.Option value="2">转租</Select.Option>
                  <Select.Option value="3">出售</Select.Option>
                  <Select.Option value="4">求购</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="是否置顶"
                name="is_stiky"
                className="isUp"
                labelCol={{ span: 5 }}
              >
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  style={{ textAlign: 'left' }}
                >
                  <Select.Option value="1">是</Select.Option>
                  <Select.Option value="0">否</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginRight: '10px', float: 'right' }}
                  >
                    查询
                  </Button>
                  <Button
                    onClick={resetSelectors}
                    style={{ marginRight: '20px', float: 'right' }}
                  >
                    重置
                  </Button>
                </Form.Item>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
      <PostTable ref={postRef} setIsFresh={setIsFresh} />
      <Pagination
        showQuickJumper
        style={{ textAlign: 'right' }}
        onChange={pageChange}
        total={total}
        key={total}
        pageSize={10}
        // current={1}
        defaultCurrent={1}
        showTotal={(total, range) =>
          `共${total}条记录, 第${range[0]}-${range[1]}条`
        }
      />
    </div>
  )
}
export default PostSelectors
